import { FC, PropsWithChildren } from 'react';
import { useSelector } from 'react-redux';
import {
	getIsMultiCardActiveSelector,
	getIsZpManySelector,
	getRadabankCurrentCardSelector,
	useAppSelector,
} from 'store';
import { RADABANK_BOOLEAN_VALUE } from 'utils/enums';
import { RadabankCardPreview } from '../CardPreview';
import { RadabankCurrentCardDetails } from '../CurrentCardDetails';

type RadabankCurrentCardPreviewProps = {
	isShowCreditDetails?: boolean;
	wrapperClassName?: string;
	detailsClassName?: string;
};

export const RadabankCurrentCardPreview: FC<PropsWithChildren<RadabankCurrentCardPreviewProps>> = ({
	isShowCreditDetails,
	wrapperClassName,
	detailsClassName,
	children,
}) => {
	const isMultiCard = useSelector(getIsMultiCardActiveSelector);

	const isManyZpCard = useSelector(getIsZpManySelector)

	const currentCard = useAppSelector(getRadabankCurrentCardSelector);

	const isZpCard = isManyZpCard && currentCard?.iszp === RADABANK_BOOLEAN_VALUE.FALSE;

	return (
		<RadabankCardPreview className={wrapperClassName} isMultiCard={isMultiCard} isZp={isZpCard}>
			<RadabankCurrentCardDetails isShowCreditDetails={isShowCreditDetails} className={detailsClassName} />
			{children}
		</RadabankCardPreview>
	);
};
